module.exports = __webpack_public_path__ + "img/7B6857_383028_BCA38F_4C3C34-256px.8dbeebae.png";